export default __webpack_public_path__ + "4e9591cb5781edab48858f6094806b62.png";